import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewHomogeneidad = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'homogeneidad',
        name: 'Homogeneidad',
        component: ViewHomogeneidad,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
